module.exports = __webpack_public_path__ + "img/administration-o.ec7b8c01.svg";